<script setup>
import { useTagStore } from "@/stores/useTagStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const tagStore = useTagStore();

function buildTagDeleteError(error) {
  const raw = error?.response?.data?.message || error?.message || "";

  let userFriendlyMessage =
    "Não é possível excluir essa TAG porque existe NOTA cadastrada vinculada a ela.";

  if (raw) userFriendlyMessage = raw;

  const looksLikeFK =
    raw.includes("foreign key constraint fails") ||
    raw.toLowerCase().includes("constraint") ||
    raw.toLowerCase().includes("foreign key");

  if (looksLikeFK) {
    userFriendlyMessage =
      "Esta tag de nota está vinculada a uma ou mais Notas e não pode ser removida.\nPara excluí-la, remova primeiro todas as notas associadas a esta tag de nota.";
  }

  return userFriendlyMessage;
}

async function onConfirmDelete() {
  try {
    await tagStore.deleteTagById(tagStore.idTag);
    tagStore.shouldForcePageOne = true;

    emit("notify", {
      type: "success",
      message: "Tag de nota apagada com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildTagDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Tag de Nota"
    messageTitle="Tem certeza que deseja excluir esta tag de nota?"
    messageSubtitle="Esta ação não pode ser desfeita."
    confirmText="Sim, excluir"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
